<app-frame
  [title]="'PIN Mismatch'"
  (back)="onBack()"
>
  <!-- H1 -->
  <span  class="e174_22">PINs entered did not match. Try again.</span>
</app-frame>
